<template>
    <div>
        <v-autocomplete
            :loading="addressLoading"
            :items="hideDetails?[]:addresses"
            :search-input.sync="searchSync"
            v-model="innerValue"
            @change="handleChange"
            hide-no-data
            :rules="rules"
            outlined

            :label="label"
        />
        <v-flex md12 style="display: none" xs12>
            <gmap-map
                :center="{lat:0, lng:0} "
                :zoom="1"
                ref="addressMap"
                style="width:100%;  height: 400px;">

                <gmap-marker
                    :clickable="true"
                    :draggable="true"
                    :position="{lat:0, lng:0}"
                    @dragend="addressMarked"
                />
            </gmap-map>
        </v-flex>

    </div>
</template>

<script>
    export default {
        props: {
            rules: {
                type: [Object, Array, String],
                default: () => {
                    return [];
                },
            },
            label: {
                type: String,
                value: ''
            },
            value: {
                type: null
            },
            countryCode: String,
            hideDetails: {
                type: Boolean,
                default: false
            }
        },
        name: "AddressAutoComplete",
        data() {
            return {
                modal: false,
                innerValue: null,
                addresses: [],
                addressLoading: false,
                searchSync: ''
            }
        },
        methods: {
            handleChange() {
                this.$emit('input', this.innerValue);
            },
            search(terms) {
                this.addressLoading = true;
                let autoCompleteService = new google.maps.places.AutocompleteService();
                autoCompleteService.getPlacePredictions(
                    {
                        input: terms,
                        componentRestrictions: {
                            country: this.countryCode
                        }
                    },
                    (predictions, status) => {
                        if (predictions != null) {
                            predictions.forEach(prediction => {
                                this.addresses.push({
                                    text: prediction.description,
                                    value: prediction.description
                                });
                            });
                        }
                        this.addressLoading = false;
                    }
                );

            },
            addressMarked() {

            }
        },
        watch: {
            searchSync(new_value) {
                if (!!new_value)
                    this.search(new_value)
            },
            value(new_value) {
                this.innerValue = new_value
            }
        },
        created() {
            if (this.value) {
                this.addresses.push({
                    text: this.value,
                    value: this.value
                });
                this.innerValue = this.value;
            }
        }
    }
</script>
<!--<script>-->
<!--    export default {-->
<!--        data: () => ({-->
<!--            addresses: [],-->
<!--            addressLoading: false,-->
<!--            search: null,-->
<!--            rules: {-->
<!--                required: value => {-->
<!--                    if (value === 'N/A') {-->
<!--                        return "Required"-->
<!--                    }-->
<!--                    return !!value || "Required."-->
<!--                }-->
<!--            }-->
<!--        }),-->
<!--        props: {-->
<!--            label: String,-->
<!--            required: Boolean,-->
<!--            value: String,-->
<!--            addressChanged: Function,-->
<!--            countryCode: String,-->
<!--        },-->
<!--        computed: {-->
<!--            modelValue: {-->
<!--                get() {-->
<!--                    if (this.value) {-->
<!--                        return this.value;-->
<!--                    } else {-->
<!--                        return "N/A";-->
<!--                    }-->
<!--                },-->
<!--                set() {-->
<!--                }-->
<!--            }-->
<!--        },-->
<!--        mounted() {-->
<!--            if (this.value) {-->
<!--                this.addresses.push({-->
<!--                    text: this.value,-->
<!--                    value: this.value-->
<!--                });-->
<!--            }-->
<!--        },-->
<!--        watch: {-->
<!--            search(val) {-->
<!--                val && val !== this.select && this.searchAddresses(val);-->
<!--            }-->
<!--        },-->
<!--        methods: {-->
<!--            handleChange() {-->

<!--            },-->
<!--            searchAddresses(terms) {-->
<!--                this.addressLoading = true;-->
<!--                let autoCompleteService = new google.maps.places.AutocompleteService();-->
<!--                autoCompleteService.getPlacePredictions(-->
<!--                    {-->
<!--                        input: terms,-->
<!--                        // types: ['(regions)'],-->
<!--                        componentRestrictions: {-->
<!--                            country: this.countryCode-->
<!--                        }-->
<!--                    },-->
<!--                    (predictions, status) => {-->
<!--                        if (predictions != null) {-->
<!--                            predictions.forEach(prediction => {-->
<!--                                this.addresses.push({-->
<!--                                    text: prediction.description,-->
<!--                                    value: prediction.description-->
<!--                                });-->
<!--                            });-->
<!--                        }-->
<!--                        this.addressLoading = false;-->
<!--                    }-->
<!--                );-->
<!--            },-->
<!--            addressMarked() {-->

<!--            }-->
<!--        }-->
<!--    };-->
<!--</script>-->
